export const Licenca = {
  protocolo: null,
  modalidade: null,
  dataCriacao: null,
  status: null,
  dataAtivacao: null,
};
